// src/components/DashboardLayout.js
import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./AIPage.css";
import Sidebar from "../Layout/Sidebar";
import Topbar from "../Layout/Topbar";
import { ToastContainer, toast } from "react-toastify";
import { useToast } from "../../contexts/ToastContext";
import { apiRequest } from "../../services/api";
import Loader from "../Common/Loader";
import { encryptData } from "../Common/encryptionUtils";

import {
  Button,
  MenuItem,
  Select,
  Box,
  Typography,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Grid,
  TableHead,
  TextField,
  IconButton,
  CircularProgress,
  Chip,
  Divider,
} from "@mui/material";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const AIPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const pageLoading = (data) => {
    setLoading(data);
  };

  useEffect(() => {
    // AccessLog("Payroll Configuration");
  }, []);

  const premiseData = (data) => {};

  const authToken = localStorage.getItem("authToken");

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const [confirmMapDialogOpen, setConfirmMapDialogOpen] = useState(false);

  const handleConfirmPopUpOpen = () => {
    setConfirmDialogOpen(true);
  };

  const handleDisconnectCancel = () => {
    setConfirmDialogOpen(false);
  };

  const createEmployeeMappingData = async () => {
    setConfirmMapDialogOpen(false);

    if (connectedDetails?.platform === "QuickBooks") {
      await createQuickbooksEmployeeMapping(mappedUsers);
    } else if (connectedDetails?.platform === "Zoho") {
      await createZohoEmployeeMapping(mappedUsers);
    } else if (connectedDetails?.platform === "Gusto") {
      await createGustoEmployeeMapping(mappedUsers);
    }
  };

  const handleCancelMapping = () => {
    setConfirmMapDialogOpen(false);
  };

  // const Title = "Settings";

  const { toastMessage, clearToast } = useToast();
  const [userList, setUserList] = useState([]);
  const [connectedDetails, setConnectedDetails] = useState(null);
  const [platformEmployeeDetails, setPlatformEmployeeDetails] = useState(null);
  const [selectedPremise, setSelectedPremise] = useState(
    JSON.parse(localStorage.getItem("selectedTopBarPremises"))
  );

  useEffect(() => {
    if (toastMessage) {
      toast.success(toastMessage);
      clearToast(); // Clear the toast message after displaying it
    }
  }, [toastMessage, clearToast]);

  const [status, setStatus] = useState(null);
  const [selectedOption, setSelectedOption] = useState(
    window.location.hostname == "web.businesstime.us" ||
      window.location.hostname == "webgamma.businesstime.us"
      ? "QuickBooks"
      : "Zoho"
  );
  const [error, setError] = useState("");

  // Check redirect callback
  useEffect(() => {
    checkConnectedStatus();
  }, []);

  // Check redirect callback
  // useEffect(() => {
  //   if (!connectedDetails) return;
  //   console.log("connectedDetails?.platform-->", connectedDetails?.platform);
  //   if (connectedDetails?.platform == "QuickBooks") {
  //     getEmployess();
  //     fetchMappedUsers(selectedPremise?.value);
  //   } else {
  //     getZohoEmployess();
  //   }
  //   fetchAlluser(selectedPremise?.value);
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const statusParam = urlParams.get("status");
  //   // if (statusParam === "success") {
  //   //   setStatus("Connected Successfully ✅");
  //   // }
  // }, [connectedDetails]);

  const customerDetails = JSON.parse(localStorage.getItem("customerDetails"));

  const checkConnectedStatus = async () => {
    pageLoading(true);
    try {
      const headers = { Authorization: `Bearer ${authToken}` };
      const policyResponse = await apiRequest(
        `web_api/admin/payroll/status?customer_account_id=${customerDetails?.customerAccountId}`,
        "GET",
        null,
        headers
      );

      if (
        policyResponse?.data?.status_code === 200 &&
        policyResponse.data?.data
      ) {
        const customer_details = policyResponse.data.data;
        setConnectedDetails(customer_details);

        // Call dependent APIs here, after state update
        if (customer_details.platform === "QuickBooks") {
          getEmployess();
          fetchMappedUsers(selectedPremise?.value);
        } else if (customer_details.platform === "Zoho") {
          getZohoEmployess();
          fetchZohoMappedUsers(selectedPremise?.value);
        } else if (customer_details.platform === "Gusto") {
          getGustoEmployess();
          fetchGustoMappedUsers(selectedPremise?.value);
        }
        fetchAlluser(selectedPremise?.value);
      } else {
        console.error(
          "Error: Invalid status code",
          policyResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, { position: "top-right", autoClose: 4000 });
    } finally {
      pageLoading(false);
    }
  };

  console.log("selectedOption---->", selectedOption);

  const handleConnect = () => {
    if (!selectedOption) {
      setError("Please select a payroll software to connect.");
      return;
    }
    setError("");
    if (selectedOption == "QuickBooks") {
      if (window.location.hostname == "web.businesstime.us") {
        window.location.href = `https://businesstime.us/businesstime_api/public/web_api/admin/intuit/connect?customer_account_id=${customerDetails?.customerAccountId}`;
      } else {
        window.location.href = `https://businesstime.us/business-i_backend_uat/public/web_api/admin/intuit/connect?customer_account_id=${customerDetails?.customerAccountId}`;
      }
    } else if (selectedOption == "Gusto") {
      if (window.location.hostname == "web.businesstime.us") {
        window.location.href = `https://businesstime.us/businesstime_api/public/web_api/admin/gusto/connect?customer_account_id=${customerDetails?.customerAccountId}`;
      } else {
        window.location.href = `https://businesstime.us/business-i_backend_uat/public/web_api/admin/gusto/connect?customer_account_id=${customerDetails?.customerAccountId}`;
      }
    } else if (selectedOption == "Zoho") {
      if (window.location.hostname == "web.businesstime.us") {
        window.location.href = `https://businesstime.us/businesstime_api/public/web_api/admin/zoho/connect?customer_account_id=${customerDetails?.customerAccountId}`;
      } else if (window.location.hostname == "web.businesstime.app") {
        window.location.href = `https://businesstime.app/businesstime_api/public/web_api/admin/zoho/connect?customer_account_id=${customerDetails?.customerAccountId}`;
      } else if (window.location.hostname == "webgamma.businesstime.us") {
        window.location.href = `https://businesstime.us/business-i_backend_uat/public/web_api/admin/zoho/connect?customer_account_id=${customerDetails?.customerAccountId}`;
      } else if (window.location.hostname == "webgamma.businesstime.app") {
        window.location.href = `https://businesstime.app/business-i_backend_uat/public/web_api/admin/zoho/connect?customer_account_id=${customerDetails?.customerAccountId}`;
      }
    }
  };

  const handlePremiseSelect = (selected) => {
    if (selected?.value) {
      pageLoading(true);
      if (connectedDetails?.platform === "QuickBooks") {
        fetchMappedUsers(selected?.value);
      } else if (connectedDetails?.platform === "Zoho") {
        fetchZohoMappedUsers(selected?.value);
      } else if (connectedDetails?.platform === "Gusto") {
        fetchGustoMappedUsers(selected?.value);
      }

      fetchAlluser(selected.value);
      setSelectedPremise(selected);
    }
  };

  const handleDisconnectConfirm = async () => {
    setConfirmDialogOpen(false);
    // Call your deactivation API here
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        customer_account_id: customerDetails?.customerAccountId,
      };
      const apiResponse = await apiRequest(
        "/web_api/admin/disconnectQuickBooksPayrollService",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        setStatus("disconnect");
        const handleFetchAndToast = async () => {
          window.location.reload();
          // Step 2: Show success message after 1 second delay
          setTimeout(() => {
            toast.success(apiResponse.data.message, {
              position: "top-right",
              autoClose: 4000,
            });
          }, 500);
        };

        // Call the async function
        handleFetchAndToast();
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleZohoDisconnectConfirm = async () => {
    setConfirmDialogOpen(false);
    // Call your deactivation API here
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        customer_account_id: customerDetails?.customerAccountId,
      };
      const apiResponse = await apiRequest(
        "/web_api/admin/disconnectZohoPayrollService",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        setStatus("disconnect");
        const handleFetchAndToast = async () => {
          window.location.reload();
          // Step 2: Show success message after 1 second delay
          setTimeout(() => {
            toast.success(apiResponse.data.message, {
              position: "top-right",
              autoClose: 4000,
            });
          }, 500);
        };

        // Call the async function
        handleFetchAndToast();
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleGustoDisconnectConfirm = async () => {
    setConfirmDialogOpen(false);
    // Call your deactivation API here
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        customer_account_id: customerDetails?.customerAccountId,
      };
      const apiResponse = await apiRequest(
        "/web_api/admin/disconnectGustoPayrollService",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        setStatus("disconnect");
        const handleFetchAndToast = async () => {
          window.location.reload();
          // Step 2: Show success message after 1 second delay
          setTimeout(() => {
            toast.success(apiResponse.data.message, {
              position: "top-right",
              autoClose: 4000,
            });
          }, 500);
        };

        // Call the async function
        handleFetchAndToast();
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  const getEmployess = async () => {
    pageLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const policyResponse = await apiRequest(
        `web_api/admin/getEmployeesFromPayrollService?customer_account_id=${customerDetails?.customerAccountId?.toString()}`,
        "GET",
        null,
        headers
      );

      if (
        policyResponse?.data?.status_code === 200 &&
        policyResponse?.data?.data
      ) {
        const customer_details = policyResponse.data?.data;
        setOriginalUsers(customer_details);
        setPlatformEmployeeDetails(customer_details);
        setTimeout(() => {
          pageLoading(false);
        }, 200);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 200);
        console.error(
          "Error: Invalid status code",
          policyResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const getZohoEmployess = async () => {
    pageLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const policyResponse = await apiRequest(
        `web_api/admin/fetchZohoEmployees?customer_account_id=${customerDetails?.customerAccountId?.toString()}`,
        "GET",
        null,
        headers
      );

      if (
        policyResponse?.data?.status_code === 200 &&
        policyResponse?.data?.data
      ) {
        const customer_details = policyResponse.data?.data;
        setOriginalUsers(customer_details);
        setPlatformEmployeeDetails(customer_details);
        setTimeout(() => {
          pageLoading(false);
        }, 200);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 200);
        console.error(
          "Error: Invalid status code",
          policyResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const getGustoEmployess = async () => {
    pageLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const policyResponse = await apiRequest(
        `web_api/admin/fetchGustoEmployees?customer_account_id=${customerDetails?.customerAccountId?.toString()}`,
        "GET",
        null,
        headers
      );

      if (
        policyResponse?.data?.status_code === 200 &&
        policyResponse?.data?.data
      ) {
        const customer_details = policyResponse.data?.data;
        setOriginalUsers(customer_details);
        setOriginalUsers1(customer_details);
        setPlatformEmployeeDetails(customer_details);
        setTimeout(() => {
          pageLoading(false);
        }, 200);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 200);
        console.error(
          "Error: Invalid status code",
          policyResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const fetchAlluser = async (premise_id) => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const userResponse = await apiRequest(
        `api/user/getstaffdetailsbypremise?premise_id=${encryptData(
          premise_id?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (
        userResponse?.data?.status_code === 200 &&
        userResponse?.data?.data?.staffdetails
      ) {
        const user_details = userResponse.data?.data?.staffdetails;
        setSelectedUsers(user_details);
        setSelectedUsers1(user_details);
        setTimeout(() => {
          pageLoading(false);
        }, 100);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 100);
        console.error(
          "Error: Invalid status code",
          userResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const fetchMappedUsers = async (premise_id) => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const userResponse = await apiRequest(
        `web_api/admin/fetchQuickbooksMappedEmployee?premise_id=${encryptData(
          premise_id?.toString()
        )}&customer_account_id=${encryptData(
          customerDetails?.customerAccountId?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (userResponse?.data?.status_code === 200 && userResponse?.data?.data) {
        const user_details = userResponse.data?.data;
        console.log("user_details--->", user_details);
        setAlreadyMappedUsers(user_details);
        setTimeout(() => {
          pageLoading(false);
        }, 100);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 100);
        console.error(
          "Error: Invalid status code",
          userResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const fetchZohoMappedUsers = async (premise_id) => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const userResponse = await apiRequest(
        `web_api/admin/fetchZohoMappedEmployee?premise_id=${encryptData(
          premise_id?.toString()
        )}&customer_account_id=${encryptData(
          customerDetails?.customerAccountId?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (userResponse?.data?.status_code === 200 && userResponse?.data?.data) {
        const user_details = userResponse.data?.data;
        setAlreadyMappedUsers(user_details);
        setTimeout(() => {
          pageLoading(false);
        }, 100);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 100);
        console.error(
          "Error: Invalid status code",
          userResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const fetchGustoMappedUsers = async (premise_id) => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const userResponse = await apiRequest(
        `web_api/admin/fetchGustoMappedEmployee?premise_id=${encryptData(
          premise_id?.toString()
        )}&customer_account_id=${encryptData(
          customerDetails?.customerAccountId?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (userResponse?.data?.status_code === 200 && userResponse?.data?.data) {
        const user_details = userResponse.data?.data;
        setAlreadyMappedUsers(user_details);
        setTimeout(() => {
          pageLoading(false);
        }, 100);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 100);
        console.error(
          "Error: Invalid status code",
          userResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const reorderSelectedUsers = (alreadyMappedUsers, selectedUsers) => {
    if (!alreadyMappedUsers || alreadyMappedUsers.length === 0) {
      return selectedUsers; // no reorder needed
    }
    console.log("ReOrder");
    // Create a lookup for quick access by user_id
    const selectedUserMap = new Map(selectedUsers.map((u) => [u.user_id, u]));

    // Reorder based on alreadyMappedUsers order
    const reordered = alreadyMappedUsers
      .map((mapped) => selectedUserMap.get(mapped.user_id)) // get from selectedUsers
      .filter((u) => u !== undefined); // remove if not found

    // Append unmapped users at the end (optional)
    const unmapped = selectedUsers.filter(
      (u) => !alreadyMappedUsers.some((mapped) => mapped.user_id === u.user_id)
    );

    return [...reordered, ...unmapped];
  };

  const reorderOriginalUsers = (alreadyMappedUsers, originalUsers) => {
    if (!alreadyMappedUsers || alreadyMappedUsers.length === 0) {
      return originalUsers; // no reorder needed
    }

    // Detect key based on platform
    const getOriginalKey = (u) => {
      switch (connectedDetails?.platform) {
        case "QuickBooks":
          return u.Id;
        case "Zoho":
          return u["Employee ID"]; // ✅ fixed: use "Employee ID"
        case "Gusto":
          return u.uuid; // ✅ use uuid (as per mergedUsers code)
        default:
          return u.uuid; // fallback
      }
    };

    const getMappedKey = (mapped) => {
      switch (connectedDetails?.platform) {
        case "QuickBooks":
          return mapped.qb_employee_id;
        case "Zoho":
          return mapped.zoho_employee_id;
        case "Gusto":
          return mapped.gusto_employee_id;
        default:
          return mapped.gusto_employee_id; // fallback
      }
    };

    // Create a lookup for quick access by user_id
    const selectedUserMap = new Map(
      originalUsers.map((u) => [getOriginalKey(u), u])
    );

    // Reorder based on alreadyMappedUsers order
    const reordered = alreadyMappedUsers
      .map((mapped) => selectedUserMap.get(getMappedKey(mapped)))
      .filter((u) => u !== undefined);

    // Append unmapped users at the end
    const unmapped = originalUsers.filter(
      (u) =>
        !alreadyMappedUsers.some(
          (mapped) => getMappedKey(mapped) === getOriginalKey(u)
        )
    );

    return [...reordered, ...unmapped];
  };

  console.log("statusstatus--->", status);

  const [open, setOpen] = useState(false);

  const [originalUsers, setOriginalUsers] = useState([]);
  const [originalUsers1, setOriginalUsers1] = useState([]);

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUsers1, setSelectedUsers1] = useState([]);

  const [alreadyMappedUsers, setAlreadyMappedUsers] = useState([]);

  console.log("originalUsers--->", originalUsers);

  console.log("selectedUsers--->", selectedUsers);

  // Handle reordering
  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const { source, destination } = result;

    if (source.droppableId === destination.droppableId) {
      // Reorder in same table
      if (source.droppableId === "original") {
        const items = Array.from(originalUsers);
        const [reordered] = items.splice(source.index, 1);
        items.splice(destination.index, 0, reordered);
        setOriginalUsers(items);
      } else {
        const items = Array.from(selectedUsers);
        const [reordered] = items.splice(source.index, 1);
        items.splice(destination.index, 0, reordered);
        setSelectedUsers(items);
      }
    }

    setSubmitMessage("");
    setIsSuccess(null);
  };

  const [submitMessage, setSubmitMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(null);
  const [mappedUsers, setMappedUsers] = useState([]);

  console.log("connectedDetails--->", connectedDetails);

  // const handleSubmit = (values) => {
  //   // Build merged array (include all, even if unmatched)
  //   const mergedUsers = selectedUsers
  //     .slice(0, originalUsers.length) // ensure same count
  //     .map((selected, i) => {
  //       if (!selected || !originalUsers[i]) return null;

  //       const full_name = `${selected.first_name} ${selected.last_name}`;
  //       const original_full_name =
  //         connectedDetails?.platform == "QuickBooks"
  //           ? originalUsers[i].Name
  //           : `${originalUsers[i]["First Name"]} ${originalUsers[i]["Last Name"]}`;
  //       const employee_id =
  //         connectedDetails?.platform == "QuickBooks"
  //           ? originalUsers[i].Id
  //           : originalUsers[i]["Employee ID"];
  //       const originalNameFirstWord = (original_full_name || "").split(" ")[0];
  //       const selectedNameFirstWord = full_name.split(" ")[0] || "";

  //       const isMatch = originalNameFirstWord === selectedNameFirstWord;

  //       return {
  //         user_id: selected.user_id, // from selected
  //         staff_id: selected.staff_id, // from selected
  //         [connectedDetails?.platform === "QuickBooks"
  //           ? "qb_employee_id"
  //           : "zoho_employee_id"]: employee_id, // from original
  //         [connectedDetails?.platform === "QuickBooks"
  //           ? "qb_employee_name"
  //           : "zoho_employee_name"]: original_full_name, // from original
  //         matched: isMatch, // extra flag (optional, useful for UI/debug)
  //       };
  //     })
  //     .filter(Boolean);

  //   // Check if all matched
  //   const allMatched = mergedUsers.every((u) => u.matched);

  //   if (allMatched) {
  //     setSubmitMessage("✅ All selected employees match the original order");
  //     setIsSuccess(true);
  //     setMappedUsers(mergedUsers);
  //     connectedDetails?.platform === "QuickBooks"
  //       ? createQuickbooksEmployeeMapping(mergedUsers)
  //       : createZohoEmployeeMapping(mergedUsers);
  //   } else {
  //     console.log("originalUsersNotMatch--->", originalUsers);
  //     console.log("selectedUsersNotMatch--->", selectedUsers);
  //     console.log("mergedUsers (with matched/unmatched)--->", mergedUsers);
  //     setMappedUsers(mergedUsers);
  //     setConfirmMapDialogOpen(true);
  //     setIsSuccess(false);
  //   }

  //   // 👉 Console final flat array
  //   console.log("Final merged Users:", mergedUsers);
  // };

  const handleSubmit = (values) => {
    // Build merged array (include all, even if unmatched)
    const mergedUsers = selectedUsers
      .slice(0, originalUsers.length) // ensure same count
      .map((selected, i) => {
        if (!selected || !originalUsers[i]) return null;

        const full_name = `${selected.first_name} ${selected.last_name}`;

        // 🔑 Handle platform-specific fields
        let original_full_name = "";
        let employee_id = "";

        if (connectedDetails?.platform === "QuickBooks") {
          original_full_name = originalUsers[i].Name;
          employee_id = originalUsers[i].Id;
        } else if (connectedDetails?.platform === "Zoho") {
          original_full_name = `${originalUsers[i]["First Name"]} ${originalUsers[i]["Last Name"]}`;
          employee_id = originalUsers[i]["Employee ID"];
        } else if (connectedDetails?.platform === "Gusto") {
          original_full_name =
            originalUsers[i].first_name + " " + originalUsers[i].last_name;
          employee_id = originalUsers[i].uuid; // Gusto employees have `id`
        }

        const originalNameFirstWord = (original_full_name || "").split(" ")[0];
        const selectedNameFirstWord = full_name.split(" ")[0] || "";

        const isMatch = originalNameFirstWord === selectedNameFirstWord;

        // Return common structure with platform-specific IDs
        return {
          user_id: selected.user_id, // from selected
          staff_id: selected.staff_id, // from selected

          // ✅ Dynamic key assignment based on platform
          ...(connectedDetails?.platform === "QuickBooks" && {
            qb_employee_id: employee_id,
            qb_employee_name: original_full_name,
          }),
          ...(connectedDetails?.platform === "Zoho" && {
            zoho_employee_id: employee_id,
            zoho_employee_name: original_full_name,
          }),
          ...(connectedDetails?.platform === "Gusto" && {
            gusto_employee_id: employee_id,
            gusto_employee_name: original_full_name,
            gusto_job_id: originalUsers[i].jobs[0].uuid,
            company_uuid: originalUsers[i].company_uuid,
          }),

          matched: isMatch, // extra flag (optional, useful for UI/debug)
        };
      })
      .filter(Boolean);

    // Check if all matched
    const allMatched = mergedUsers.every((u) => u.matched);

    if (allMatched) {
      setSubmitMessage("✅ All selected employees match the original order");
      setIsSuccess(true);
      setMappedUsers(mergedUsers);

      // 👉 Trigger respective API
      if (connectedDetails?.platform === "QuickBooks") {
        createQuickbooksEmployeeMapping(mergedUsers);
      } else if (connectedDetails?.platform === "Zoho") {
        createZohoEmployeeMapping(mergedUsers);
      } else if (connectedDetails?.platform === "Gusto") {
        console.log("originalUsersNotMatch--->", originalUsers);
        createGustoEmployeeMapping(mergedUsers);
      }
    } else {
      console.log("originalUsersNotMatch--->", originalUsers);
      console.log("selectedUsersNotMatch--->", selectedUsers);
      console.log("mergedUsers (with matched/unmatched)--->", mergedUsers);
      setMappedUsers(mergedUsers);
      setConfirmMapDialogOpen(true);
      setIsSuccess(false);
    }

    // 👉 Console final flat array
    console.log("Final merged Users:", mergedUsers);
  };

  const createQuickbooksEmployeeMapping = async (matchedUsers) => {
    // setConfirmDialogOpen(false);
    // Call your deactivation API here
    setLoading(true);
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        premise_id: selectedPremise?.value,
        customer_account_id: customerDetails?.customerAccountId,
        matchedUsers: matchedUsers,
      };
      const apiResponse = await apiRequest(
        "/web_api/admin/createQuickbooksEmployeeMapping",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        setOpen(false);
        setSubmitMessage("");
        toast.success(apiResponse.data.message, {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  const createZohoEmployeeMapping = async (matchedUsers) => {
    // setConfirmDialogOpen(false);
    // Call your deactivation API here
    setLoading(true);
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        premise_id: selectedPremise?.value,
        customer_account_id: customerDetails?.customerAccountId,
        matchedUsers: matchedUsers,
      };
      const apiResponse = await apiRequest(
        "/web_api/admin/createZohoEmployeeMapping",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        setOpen(false);
        setSubmitMessage("");
        toast.success(apiResponse.data.message, {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  const createGustoEmployeeMapping = async (matchedUsers) => {
    // setConfirmDialogOpen(false);
    // Call your deactivation API here
    setLoading(true);
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        premise_id: selectedPremise?.value,
        customer_account_id: customerDetails?.customerAccountId,
        matchedUsers: matchedUsers,
      };
      const apiResponse = await apiRequest(
        "/web_api/admin/createGustoEmployeeMapping",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        setOpen(false);
        setSubmitMessage("");
        toast.success(apiResponse.data.message, {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (alreadyMappedUsers?.length > 0) {
      console.log("user_detailsData--->", alreadyMappedUsers);
      const newOrder = reorderSelectedUsers(alreadyMappedUsers, selectedUsers);
      const newOriginalOrder = reorderOriginalUsers(
        alreadyMappedUsers,
        originalUsers
      );
      console.log("newOriginalOrder--->", newOriginalOrder);
      setSelectedUsers(newOrder);
      setOriginalUsers(newOriginalOrder);
    }
  }, [alreadyMappedUsers, selectedUsers1, originalUsers1]);

  // const handleSubmit = () => {
  //   // Filter only mapped employees
  //   const mappedEmployees = selectedUsers.filter((selected, i) => {
  //     if (!selected || !originalUsers[i]) return false; // ✅ protect against undefined

  //     const full_name = `${selected.first_name} ${selected.last_name}`;
  //     const originalNameFirstWord = (originalUsers[i].Name || "").split(" ")[0];
  //     const selectedNameFirstWord = full_name.split(" ")[0] || "";

  //     return originalNameFirstWord === selectedNameFirstWord;
  //   });

  //   // Check if all employees are matched
  //   if (mappedEmployees.length === originalUsers.length) {
  //     setSubmitMessage("✅ All selected employees match the original order");
  //     setIsSuccess(true);
  //   } else {
  //     setSubmitMessage(
  //       "❌ BusinessTime employees are not in the same order as QuickBooks employees."
  //     );
  //     setIsSuccess(false);
  //   }

  //   // 👉 Console the new array without unmapped employees
  //   console.log("Mapped Employees:", mappedEmployees);
  // };

  console.log("selectedUsers---->", selectedUsers);
  console.log("alreadyMappedUsers--->", alreadyMappedUsers);

  const arrowLength = Math.min(selectedUsers?.length, originalUsers?.length);

  console.log("arrowLength--->", arrowLength);

  const [messages, setMessages] = useState([
    {
      sender: "bot",
      text: "👋 Hello! I'm your assistant. How can I help you today?",
    },
  ]);
  const [newMessage, setNewMessage] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const messagesEndRef = useRef(null);

  // auto scroll
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSend = async () => {
    if (!newMessage.trim()) return;

    const userMessage = { sender: "user", text: newMessage };
    setMessages((prev) => [...prev, userMessage]);

    // placeholder bot bubble
    const botIndex = messages.length + 1;
    setMessages((prev) => [...prev, { sender: "bot", text: "" }]);

    setLoading(true);

    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      };

      const payload = {
        text: newMessage, // backend expects "text"
        customer_account_id: customerDetails?.customerAccountId,
      };

      // use fetch, not apiRequest, for stream
      const response = await fetch("/web_api/admin/assistant/chat", {
        method: "POST",
        headers,
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to connect to assistant.");
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let botText = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        botText += chunk;

        // update progressively
        setMessages((prev) =>
          prev.map((msg, i) =>
            i === botIndex ? { ...msg, text: botText } : msg
          )
        );
      }
    } catch (error) {
      console.error("Assistant chat error:", error);
      setMessages((prev) =>
        prev.map((msg, i) =>
          i === botIndex ? { ...msg, text: "⚠️ Error getting response." } : msg
        )
      );
    } finally {
      setLoading(false);
      setNewMessage("");
    }
  };

  const [chats, setChats] = useState([]); // list of old chats
  const [activeChat, setActiveChat] = useState(null); // which chat is open

  // create a new chat
  const handleNewChat = () => {
    const newChat = { id: Date.now(), title: "New Chat", messages: [] };
    setChats([newChat, ...chats]);
    setActiveChat(newChat.id);
    setMessages([]);
  };

  return (
    <div className="dashboard-layout">
      <Sidebar selectedPremise={selectedPremise} />
      <div className="main-content dashboardMain">
        <Topbar onPremiseSelect={handlePremiseSelect} />
        <ToastContainer />
        {loading && <Loader />}
        <div className="content">
          <div className="contentHeader d-flex align-items-center justify-content-between pb-3">
            <div className="contentDiv">
              {/* <Breadcrumb className="contentTitle">
                <Breadcrumb.Item active>{Title}</Breadcrumb.Item>
                <Breadcrumb.Item active>Time Off Configuration</Breadcrumb.Item>
              </Breadcrumb> */}
              {/* <span className="contentTitle">Report</span> */}
              {/* <span className='contentTitle'>{Title}</span> */}
            </div>
            {/* Search bar on the same row */}
          </div>
          <div className="premiseDetails">
            <div className="row premisesListDiv">
              <div className="row mt-0 g-4">
                <div
                  style={{ textAlign: "center", margin: "0px", padding: "0px" }}
                >
<Box sx={{ display: "flex", height: "100vh", backgroundColor: "#f7f9fc" }}>
      {/* Sidebar */}
      <Paper
        elevation={3}
        sx={{
          width: sidebarOpen ? 260 : 70,
          transition: "width 0.3s ease",
          background: "linear-gradient(180deg, #ffffff, #f4f6f9)",
          borderRight: "1px solid #e0e0e0",
          display: "flex",
          flexDirection: "column",
          borderRadius: "0 16px 16px 0",
          overflow: "hidden",
        }}
      >
        {/* Sidebar Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: sidebarOpen ? "space-between" : "center",
            px: 1.5,
            py: 1.5,
            background: "linear-gradient(90deg, #1976d2, #42a5f5)",
            color: "#fff",
          }}
        >
          {sidebarOpen && (
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              <i className="fas fa-robot" style={{ marginRight: "8px" }}></i>
              Assistant
            </Typography>
          )}
          <IconButton
            onClick={() => setSidebarOpen(!sidebarOpen)}
            sx={{ color: "#fff" }}
          >
            <i className={`fas ${sidebarOpen ? "fa-angle-left" : "fa-angle-right"}`}></i>
          </IconButton>
        </Box>

        {/* New Chat */}
        <Button
          variant="contained"
          fullWidth
          onClick={handleNewChat}
          sx={{
            backgroundColor: "#1976d2",
            color: "#fff",
            textTransform: "none",
            fontWeight: "bold",
            py: 1.2,
            borderRadius: 0,
            "&:hover": { backgroundColor: "#1565c0" },
          }}
        >
          <i className="fas fa-plus" style={{ marginRight: sidebarOpen ? "8px" : "0" }}></i>
          {sidebarOpen && "New Chat"}
        </Button>

        {/* Chat History */}
        <Box sx={{ flex: 1, overflowY: "auto", mt: 1 }}>
          {chats.map((chat) => (
            <Box
              key={chat.id}
              sx={{
                display: "flex",
                alignItems: "center",
                p: 1.5,
                cursor: "pointer",
                fontSize: "0.9rem",
                backgroundColor: activeChat === chat.id ? "#e3f2fd" : "transparent",
                borderRadius: "8px",
                mx: 1,
                mb: 0.5,
                "&:hover": {
                  backgroundColor: "#f1f5fb",
                  boxShadow: "inset 0 0 5px rgba(0,0,0,0.05)",
                },
              }}
              onClick={() => {
                setActiveChat(chat.id);
                setMessages(chat.messages || []);
              }}
            >
              <i
                className="fas fa-comments"
                style={{ marginRight: sidebarOpen ? "8px" : "0" }}
              ></i>
              {sidebarOpen && chat.title}
            </Box>
          ))}
        </Box>

        <Divider />
        {/* Footer */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            p: sidebarOpen ? 1 : 0,
            alignItems: sidebarOpen ? "flex-start" : "center",
          }}
        >
          <Button
            sx={{
              justifyContent: sidebarOpen ? "flex-start" : "center",
              width: "100%",
              textTransform: "none",
              color: "#333",
              "&:hover": { backgroundColor: "#f5f5f5" },
            }}
          >
            <i className="fas fa-user-circle" style={{ marginRight: sidebarOpen ? "8px" : "0" }}></i>
            {sidebarOpen && "Profile"}
          </Button>
          <Button
            sx={{
              justifyContent: sidebarOpen ? "flex-start" : "center",
              width: "100%",
              textTransform: "none",
              color: "#333",
              "&:hover": { backgroundColor: "#f5f5f5" },
            }}
          >
            <i className="fas fa-cog" style={{ marginRight: sidebarOpen ? "8px" : "0" }}></i>
            {sidebarOpen && "Settings"}
          </Button>
        </Box>
      </Paper>

      {/* Main Chat */}
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {!activeChat && (
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            p: 3,
                          }}
                        >
                          {/* <Typography
                            variant="h4"
                            sx={{ fontWeight: "bold", mb: 2, color: "#1976d2" }}
                          >
                            <i
                              className="fas fa-robot"
                              style={{ marginRight: "10px" }}
                            ></i>
                            Chat Assistant
                          </Typography> */}
                          <Typography
                            variant="body1"
                            sx={{ color: "#666", mb: 4 }}
                          >
                            Start a new conversation or select one from the
                            sidebar.
                          </Typography>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleNewChat}
                            sx={{
                              textTransform: "none",
                              fontWeight: "bold",
                              borderRadius: "8px",
                            }}
                          >
                            <i
                              className="fas fa-comment-medical"
                              style={{ marginRight: "8px" }}
                            ></i>
                            Start New Chat
                          </Button>
                        </Box>
        )}

        {activeChat && (
          <>
            {/* Messages */}
            <Box sx={{ flex: 1, p: 3, overflowY: "auto" }}>
              {messages.map((msg, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: msg.sender === "user" ? "flex-end" : "flex-start",
                    mb: 2,
                    animation: "fadeIn 0.3s ease-in-out",
                  }}
                >
                  <Paper
                    sx={{
                      maxWidth: "70%",
                      p: 1.5,
                      borderRadius: "16px",
                      backgroundColor: msg.sender === "user" ? "#1976d2" : "#f1f1f1",
                      color: msg.sender === "user" ? "#fff" : "#333",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    {msg.sender === "bot" && (
                      <i
                        className="fas fa-robot"
                        style={{ marginRight: "6px", color: "#1976d2" }}
                      ></i>
                    )}
                    {msg.text}
                  </Paper>
                </Box>
              ))}
            </Box>

            {/* Bottom Input */}
            <Box sx={{ p: 2, borderTop: "1px solid #e0e0e0", backgroundColor: "#fff" }}>
              <Box sx={{ mb: 1, display: "flex", gap: 1, flexWrap: "wrap" }}>
                {["Summarize this", "Explain in detail", "Give me steps", "Make it simple"].map(
                  (chip, i) => (
                    <Chip
                      key={i}
                      label={chip}
                      onClick={() => setNewMessage(chip)}
                      sx={{
                        cursor: "pointer",
                        backgroundColor: "#f9f9f9",
                        "&:hover": { backgroundColor: "#e0e0e0" },
                      }}
                    />
                  )
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#f7f9fc",
                  borderRadius: "25px",
                  px: 2,
                  py: 0.5,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                }}
              >
                <TextField
                  fullWidth
                  variant="standard"
                  placeholder="Type a message..."
                  InputProps={{ disableUnderline: true }}
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && handleSend()}
                  sx={{ mx: 1 }}
                />
                <IconButton
                  onClick={handleSend}
                  sx={{
                    background: "linear-gradient(45deg, #1976d2, #42a5f5)",
                    color: "#fff",
                    "&:hover": { opacity: 0.9 },
                  }}
                >
                  <i className="fas fa-paper-plane"></i>
                </IconButton>
              </Box>
            </Box>
          </>
        )}
      </Box>
    </Box>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIPage;
